import { array, enum as enum_, object, optional, string } from 'zod';

import { countVisibleQuizText } from '@/shared/features/rich-text/utils/countVisibleQuizText';

import { QuizHintSchema } from './QuizHintSchema';

export const QUESTION_REQUIRED_MESSAGE = 'Question is required';
export const QUESTION_TEXT_MAX_LENGTH = 300;

/**
 * 문제 생성에 사용된 성취기준 1건 — 코드 + 과목명 쌍.
 * AI 생성 응답(curriculumList)에서 유입되어 quiz 서버 submit 시 그대로 전달된다.
 */
export const QuizCurriculumSchema = object({
  standardCode: string(),
  subject: string(),
});

export const QuizBaseSchema = object({
  id: string(),
  type: enum_(['multiple', 'subjective', 'ox', 'essay', 'match', 'order']),
  question: string()
    .min(1, QUESTION_REQUIRED_MESSAGE)
    .refine(
      question => countVisibleQuizText(question) <= QUESTION_TEXT_MAX_LENGTH,
      QUESTION_REQUIRED_MESSAGE,
    ),
  questionRichText: optional(string()),
  questionImageUrl: optional(string()),
  hint: optional(QuizHintSchema),
  curriculumList: optional(array(QuizCurriculumSchema)),
  /**
   * curriculumList 가 부여된 시점의 문항 내용 지문(stableHash).
   * submit/스냅샷 직렬화 시 현재 내용 지문과 비교해, 어긋나면(=부여 이후 편집됨)
   * 성취기준을 제외하는 판정 기준이다. 서버로는 전송하지 않는 폼 전용 필드.
   * @see views/build/util/curriculumFingerprint.ts
   */
  curriculumFingerprint: optional(string()),
  /**
   * 문제 은행에서 담아온 문항이면 은행 문항 id. 중복 담기 판정과 출처 표기(서버가
   * 이 id 로 원작자를 채운다)에 쓰이며, 문항 내용이 아니라 fingerprint 에는 안 들어간다.
   */
  bankItemId: optional(string()),
});
